import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'documentation-template',
  templateUrl: './documentation-template.component.html',
  styleUrls: ['./documentation-template.component.sass']
})
export class DocumentationTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
